import { render, staticRenderFns } from "./Header-Portrate.vue?vue&type=template&id=3b7e8236"
import script from "./Header-Portrate.vue?vue&type=script&lang=js"
export * from "./Header-Portrate.vue?vue&type=script&lang=js"
import style0 from "./Header-Portrate.vue?vue&type=style&index=0&id=3b7e8236&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports